var modules_09e1f5ae = {"sub-row":"_4z13kh"};
import "../../../assets/DwSOD8jc.css";

export { modules_09e1f5ae as default };
//# sourceMappingURL=Row.module.less.js.map
